import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { IndividualConfig } from 'ngx-toastr/toastr/toastr-config';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { NotificationType } from '../../samwebDescription/samweb/notification/notificationType';

@Injectable({
   providedIn: 'root',
})
export class NotificationService {
   constructor(private toastr: ToastrService, private translationService: TranslateService) {}

   public translateAndShowToast(
      notificationType: NotificationType,
      titleTranslationKey: string,
      messageTranslationKey: string,
      toastConfig: Partial<IndividualConfig>
   ): Observable<ActiveToast<any>> {
      return this.translationService.get(titleTranslationKey).pipe(
         withLatestFrom(this.translationService.get(messageTranslationKey)),
         map(([title, message]) => this.showDefaultToast(notificationType, title, message, toastConfig))
      );
   }

   public showDefaultToast(notificationType: NotificationType, title: string, message: string, toastConfig: Partial<IndividualConfig>): ActiveToast<any> {
      const effectiveToastConfig = _.merge(
         <Partial<IndividualConfig>>{
            positionClass: 'toast-bottom-right',
            timeOut: 15000,
            extendedTimeOut: 5000,
            progressBar: true,
            closeButton: true,
         },
         toastConfig
      );

      let toast: ActiveToast<any>;
      switch (notificationType) {
         case NotificationType.SHOW:
            toast = this.toastr.show(message, title, effectiveToastConfig);
            break;
         case NotificationType.SUCCESS:
            toast = this.toastr.success(message, title, effectiveToastConfig);
            break;
         case NotificationType.INFO:
            toast = this.toastr.info(message, title, effectiveToastConfig);
            break;
         case NotificationType.WARN:
            toast = this.toastr.warning(message, title, effectiveToastConfig);
            break;
         default:
            toast = this.toastr.error(message, title, effectiveToastConfig);
            break;
      }
      return toast;
   }
}
